module.exports = __webpack_public_path__ + "static/media/IMG_8604-ink-min.f0aaf1d4.jpeg";